import React, { Component, PropTypes } from 'react';
import t from 'tcomb-form';
import { isEmpty } from 'lodash/lang'

const OrgLocationSchema = t.struct({
  address1: t.maybe(t.String),
  city: t.maybe(t.String),
  state: t.maybe(t.String),
  zipcode: t.maybe(t.String),
});



export default class OrganizationDetailLocationSection extends Component {
  state = {
    formValue: {
      address1: '',
      city: '',
      state: '',
      zipcode: ''
    },
    formOptions: {
      fields: {
        address1: {
          error: '',
          attrs: {
            placeholder: 'Address'
          }
        },
        city: {
          error: '',
          attrs: {
            placeholder: 'City'
          }
        },
        state: {
          error: '',
          attrs: {
            placeholder: 'State'
          }
        },
        zipcode: {
          error: '',
          attrs: {
            placeholder: 'zipcode'
          }
        },
      }
    },
    showEditFields: false
  };

  constructor(props) {
    super(props);
  };

  componentWillMount() {
    this.setState({ formValue: {
        address1: this.props.organization.address1 || "",
        city: this.props.organization.city || "",
        state: this.props.organization.state || "",
        zipcode: this.props.organization.zipcode || ""
      }
    });
  }

  onFormChange = value => {
    let newState = this.state.formValue;
    for(const key in value) {
      newState[key] = value[key];
      this.props.updateContent(key, newState[key]);
    }
    this.setState({ formValue: newState});
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.saveOrganization();
    this.setState({ showEditFields: false })
  }

  showEditFields = e => {
    e.preventDefault();
    this.setState({ showEditFields: true });
  };

  hideEditFields = e => {
    e.preventDefault();
    this.setState({ showEditFields: false });
  }

  render() {
    const { organization, isEditMode } = this.props;

    let locationSection = '';
    let header = <div className="organizationDetail-locationTitle">LOCATION</div>;

    let formFields = [];
    let editIcon = '';
    let content = '';

    let address1 = this.state.formValue.address1 || organization.address1;

    let address2 = this.state.formValue.address2 || organization.address2;

    let city = this.state.formValue.city || organization.city;

    let state = this.state.formValue.state || organization.state;

    let zipcode = this.state.formValue.zipcode || organization.zipcode;

    let is_global = this.state.formValue.zipcode || organization.is_global;

    let regions = organization.region_names;
    let regionStr = '';



    if(address1 && !city && !state && !isEmpty(regions)) {
      locationSection = <div className="organizationDetail-locationAddress">{address1}<br />{regions[regions.length - 1]} {zipcode}</div>;
    } else if(address1 && city && state) {
      locationSection = <div className="organizationDetail-locationAddress">{address1}<br />
                        {city}, {state} {zipcode}</div>;
    } else if(!address1 && address2 && city && state) {
      locationSection = <div className="organizationDetail-locationAddress">{address2}<br />{city}, {state} {zipcode}</div>;
    } else if(!address1 && city && state) {
      locationSection = <div className="organizationDetail-locationAddress">{city}, {state} {zipcode}</div>;
    }


    if (organization.is_global) {
      header = <div className="organizationDetail-locationTitle">Global</div>;
    } else if (locationSection != '') {
      header = <div className="organizationDetail-locationTitle">LOCATION</div>;
    }

    if (isEditMode) {
      header = <div className="organizationDetail-locationTitle">LOCATION <span onClick={this.showEditFields} className="organization-editIcon">
        <i className="fa fa-pencil"></i>
      </span></div>;
    }



    if(isEditMode) {
      editIcon = <span onClick={this.showEditFields} className="organization-editIcon">
        <i className="fa fa-pencil"></i>
      </span>;
      formFields =
        <div>
          <div className="OrganizationDetailLocation-formWrapper">
            <div><button className="button-primary" type="submit" onClick={this.handleSubmit}>Save</button> <button onClick={this.hideEditFields}>Cancel</button></div>
          <t.form.Form ref="locationForm"
          onChange={this.onFormChange}
          value={this.state.formValue}
          type={OrgLocationSchema}
          options={this.state.formOptions} />

          </div>

        </div>
    }


    if(this.state.showEditFields) {
      content = formFields;
    } else {
      content = locationSection;
    }

    return(
      <div className="organizationDetail-locationSection">
        {header}
        {content}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/OrganizationDetailLocationSection.jsx